export function deriveLineNumber(...values){
  const text=values.filter(Boolean).join(' ').trim();
  return text.match(/\b[A-Z]{0,4}\d{2,6}[A-Z]?\b/i)?.[0]?.toUpperCase()||String(values.find(Boolean)||'').replace(/\.pdf$/i,'').trim();
}
export function inferCourseType(value){return /powr[oó]t|return|z powrotem/i.test(String(value||''))?'return':'outbound';}
export function routeCountriesArray(sections=[]){
  const countries=[];
  sections.forEach(section=>{const value=section?.countryName||section?.countryCode||'';if(value&&!countries.includes(value))countries.push(value);});
  return countries;
}
export function normalizeClock(value){
  const text=String(value||'').trim();
  if(/^\d{2}:\d{2}:\d{2}$/.test(text))return text;
  if(/^\d{2}:\d{2}$/.test(text))return `${text}:00`;
  return new Date().toTimeString().slice(0,8);
}

export function localDate(date){
  const offset=date.getTimezoneOffset()*60000;
  return new Date(date.getTime()-offset).toISOString().slice(0,10);
}

export function sectionDistanceKm(section) {
  if (!section) return null;
  const meters = finiteNumberOrNull(section.distanceMeters);
  return meters === null ? null : round(meters / 1000);
}

export function finiteNumberOrNull(value) {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(String(value).replace(',', '.'));
  return Number.isFinite(number) && number >= 0 ? number : null;
}

export function pickCalculatorScreenshot(result) {
  const candidates = [
    result?.calculatorScreenshot,
    result?.screenshotDataUrl,
    result?.reportScreenshot,
    result?.routeReportImage,
    result?.screenshot_data_url,
  ];
  return candidates.find(value => /^data:image\/(?:png|jpe?g|webp);base64,/i.test(String(value || ''))) || '';
}

export function hasCoords(point) {
  if (!point) return false;
  if (
    point.lat === null || point.lat === undefined || point.lat === '' ||
    point.lon === null || point.lon === undefined || point.lon === ''
  ) return false;

  const lat = Number(String(point.lat).replace(',', '.'));
  const lon = Number(String(point.lon).replace(',', '.'));

  return Number.isFinite(lat) && Number.isFinite(lon) &&
    lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180 &&
    !(lat === 0 && lon === 0);
}

export function setStatus(el,t,k='neutral'){el.textContent=t;el.className=`status ${k}`;}
export function setBadge(el,t,k){el.textContent=t;el.className=`badge ${k}`;}
export function esc(v){return String(v??'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));}
export function capitalize(v){v=String(v||'').trim();return v?v[0].toLocaleUpperCase('pl-PL')+v.slice(1):'';}
export function round(v){return Math.round((Number(v)||0)*10)/10;}
export function formatDuration(s){const h=Math.floor((s||0)/3600),m=Math.round(((s||0)%3600)/60);return `${h} h ${m} min`;}
